import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css';

function Footer() {
  return (
    <footer className="main-footer">
      <div className="footer-container">

        {/* Column 1: Logo & About */}
        <div className="footer-col">
          <div className="footer-logo">
            <h2><span>MR</span> WHITE</h2>
          </div>

          <p>
            Premium laundry, dry cleaning, and ironing services in the UAE.
            Quality care for your garments, delivered to your doorstep.
          </p>

          <div className="footer-social">
            <i className="fab fa-facebook-f"></i>
            <i className="fab fa-instagram"></i>
            <i className="fab fa-whatsapp"></i>
          </div>
        </div>

        {/* Column 2: Quick Links */}
        <div className="footer-col">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about-us">About Us</Link></li>
            <li><Link to="/services">Our Services</Link></li>
            <li><Link to="/how-it-works">How It Works</Link></li>
            <li><Link to="/contact-us">Contact Us</Link></li>
          </ul>
        </div>

        {/* Column 3: Policies & Legal */}
        <div className="footer-col">
          <h3>Policies & Legal</h3>
          <ul>
            <li><Link to="/terms-and-conditions">Terms & Conditions</Link></li>
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            {/* 🎯 Added Damage Policy Link */}
            <li><Link to="/damage-policy">Damage Policy</Link></li>
            <li><Link to="/shipping-delivery-policy">Shipping / Delivery Policy</Link></li>
            <li><Link to="/refund-return-policy">Refund / Return Policy</Link></li>
            <li><Link to="/cancellation-replacement-policy">Cancellation & Replacement Policy</Link></li>
            <li><Link to="/dispute-resolution-policy">Dispute & Resolution Policy</Link></li>
            <li><Link to="/governing-law-jurisdiction">Governing Law & Jurisdiction</Link></li>
            <li><Link to="/acceptance-of-terms">Acceptance of T&C</Link></li>
            <li><Link to="/payment-methods">Payment Methods / Card Types / Currency</Link></li>
            <li><Link to="/faqs">FAQs</Link></li>
          </ul>
        </div>

        {/* Column 4: Contact Info */}
        <div className="footer-col">
          <h3>Contact Us</h3>

          <div className="contact-item">
            <i className="fas fa-map-marker-alt"></i>
            <p>Ajman -  UAE</p>
          </div>

          <div className="contact-item">
            <i className="fas fa-phone-alt"></i>
            <p>+971 58 577 9343</p>
          </div>

          <div className="contact-item">
            <i className="fas fa-envelope"></i>
            <p>customercare@mrwhiteuae.com</p>
          </div>

          <div className="contact-item">
            <i className="fas fa-credit-card"></i>
            <p>Visa, Mastercard, American Express</p>
          </div>

          <div className="contact-item">
            <i className="fas fa-money-bill-wave"></i>
            <p>Currency: AED (UAE Dirham)</p>
          </div>
        </div>

      </div>

      {/* Copyright Bar */}
      <div className="footer-bottom">
        <p>&copy; 2026 MR WHITE LAUNDRY. All Rights Reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;